import { Injectable, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable, BehaviorSubject } from 'rxjs';
import { Campaign } from '../shared/models/campaign';


export interface IEmail {
  emailAddress: string;
  firstName: string;
  lastName: string;
  zipCode: string;
  quote?: string;
  phone?: string;
  date?: string;
  }

@Injectable({
  providedIn: 'root'
})
export class LiveUpdateService implements OnInit {

  public authenticated: BehaviorSubject<boolean>;
  public authenticated$: Observable<boolean>;
  public campaigns: BehaviorSubject<Campaign[]>;
  public campaigns$: Observable<Campaign[]>;
  public emails: BehaviorSubject<IEmail[]>;
  public emails$: Observable<IEmail[]>;
  public quotes: BehaviorSubject<IEmail[]>;
  public quotes$: Observable<IEmail[]>;

  constructor(private auth: AngularFireAuth, private db: AngularFireDatabase) {
    this.authenticated = new BehaviorSubject(false);
    this.authenticated$ = this.authenticated.asObservable();
    this.campaigns = new BehaviorSubject(null);
    this.campaigns$ = this.campaigns.asObservable();
    this.emails = new BehaviorSubject(null);
    this.emails$ = this.emails.asObservable();
    this.quotes = new BehaviorSubject(null);
    this.quotes$ = this.quotes.asObservable();
   }

   ngOnInit() {


  }

  createItem(item: Campaign) {
    const dbRef = this.db.database.ref('campaigns');
    dbRef.push(item).then(ref => {
      dbRef.child(`${ref.key}/itemKey`).set(ref.key);
    });
  }

  async signIn(email: string, pass: string): Promise<any> {
    const res = await this.auth.auth
      .signInWithEmailAndPassword(email, pass);
    if (res) {
      localStorage.setItem('auth_user', JSON.stringify(res));
      this.authenticated.next(true);
      this.getCampaigns();
    }

    return res;
  }

  getCampaigns() {
    // const user = JSON.parse(localStorage.getItem('auth_user'));
    this.db
        .list('/campaigns').valueChanges()
        .subscribe(campaigns => {
          campaigns.map((camps: Campaign) => {
            camps.readonly = true;
            campaigns.sort((a: Campaign, b: Campaign) => {
              return (a.displayNumber - b.displayNumber);
            });

            this.campaigns.next(campaigns);
        });
  });
}

getEmails() {
  return this.db.list('/emails').valueChanges()
  .subscribe((emails: IEmail[]) => {
   this.emails.next(emails);
  });
}

getQuotes() {
  return this.db.list('/quotes').valueChanges()
  .subscribe((quotes: IEmail[]) => {
   this.quotes.next(quotes);
  });
}

public updateCampaigns(campaign: Campaign) {
  const dbRef = this.db.database.ref('campaigns');
  dbRef.child(`${campaign.itemKey}`).set(campaign).then((res) => {
    if (res) {
     this.getCampaigns();
    }
  });
}

public createEmail(email: IEmail) {
  const dbRef = this.db.database.ref('emails');
  dbRef.push(email).then(ref => {
    dbRef.child(`${ref.key}/itemKey`).set(ref.key);
  });
}

public createQuote(email: IEmail) {
  const dbRef = this.db.database.ref('quotes');
  dbRef.push(email).then(ref => {
    dbRef.child(`${ref.key}/itemKey`).set(ref.key);
  });
}

public deleteRecord(campaign: Campaign) {
  const dbRef = this.db.database.ref('campaigns');
  dbRef.child(`${campaign.itemKey}`).remove().then((res) => {
    if (res) {
     this.getCampaigns();
    }
  });
}

public deleteQuoteRecord(key: string) {
  const dbRef = this.db.database.ref('quotes');
  dbRef.child(key).remove().then((res) => {
    if (res) {
     this.getQuotes();
    }
  });
}
}
